import {GET_FLAG_NOTI_FINE_REG, SET_FLAG_READ_NOTIFICATION, SET_STD_KEY_FINE_REG_NOTI_READ} from '../actionTypes'

const localAction = [
    GET_FLAG_NOTI_FINE_REG, SET_FLAG_READ_NOTIFICATION, SET_STD_KEY_FINE_REG_NOTI_READ
]
export default function (state = {}, action) {
    // let user = JSON.parse(localStorage.getItem('user'))

    let user
    let stdId
    let staffName
    let userType
    let semester
    let academicYear
    let notifications
    let notiFineRegs
    let key
    let notiFineRegFlag

    if (localAction.includes(action.type)) {
        user = action.payload.user
        stdId = user?.student?.stdId
        staffName = user?.staff?.loginName
        userType = user?.userType
        semester = user?.semester
        academicYear = user?.user?.academicYear

        notifications = JSON.parse(localStorage.getItem('notifications'))
        notiFineRegs = notifications?.notiFineRegs || []
        key = ''
        notiFineRegFlag = '0'

        if (userType === '3') {
            key = `STF_${staffName}_${academicYear}_${semester}`
        } else {
            key = `STD_${stdId}_${academicYear}_${semester}`
        }
    }

    switch (action.type) {
        case SET_FLAG_READ_NOTIFICATION:
            console.log("SET_FLAG_READ_NOTIFICATION", action)

            if (notifications) {
                let findResult = notiFineRegs.find(f => f[key])
                console.log("findResult", findResult)
                if (findResult !== undefined) { //* has old key
                    findResult[key] = '1'
                    console.log("findResult updateKey", findResult)
                }
                notiFineRegFlag = findResult[key]
                notifications.notiFineRegs = notiFineRegs
            }
            return {...state, ...notifications, notiFineRegFlag}

        case SET_STD_KEY_FINE_REG_NOTI_READ:
            console.log("SET_STD_KEY_FINE_REG_NOTI_READ", action)

            if (!notifications) { //* new user login
                let item = {[key]: '0'}
                notiFineRegs = []
                notiFineRegs.push(item)
                notifications = {}
                notifications.notiFineRegs = notiFineRegs
                console.log("notifications", notifications)
                console.log("notiFineRegFlag if", notiFineRegFlag)
                return {...state, ...notifications, notiFineRegFlag: item[key]}
            } else if (notifications && notifications.notiFineRegs.length > 0) { //* change user login
                let item = {[key]: '0'}
                notiFineRegs = notifications.notiFineRegs
                let duplicateKey = notiFineRegs.filter(f => key in f)
                console.log("findNotiFineRegs filter", duplicateKey)
                if (duplicateKey.length === 0) {
                    notiFineRegs.push(item)
                }
                notifications.notiFineRegs = notiFineRegs
                return {...state, ...notifications, notiFineRegFlag: item[key]}
            } else {
                let findNotiFineRegs = notiFineRegs.find(f => f[key])
                if (findNotiFineRegs !== undefined) {
                    notiFineRegFlag = findNotiFineRegs[key]
                }
                console.log("notiFineRegFlag else", notiFineRegFlag)
                return {...state, ...notifications, notiFineRegFlag}
            }

        case GET_FLAG_NOTI_FINE_REG:
            let findNotiFineRegs = notiFineRegs.find(f => f[key])
            if (findNotiFineRegs !== undefined) {
                notiFineRegFlag = findNotiFineRegs[key]
            }
            console.log("notiFineRegFlag", notiFineRegFlag)

            return {...state, notiFineRegFlag}

        default:
            if (notiFineRegs) {
                let findNotiFineReg = notiFineRegs.find(f => f[key])
                if (findNotiFineReg) {
                    notiFineRegFlag = findNotiFineReg[key]
                }
                return {...state, ...notifications, notiFineRegFlag}
            } else {
                return {...state}
            }
    }
}
